import Title from 'components/Typography/Title';
import {
  GiftGrid,
  GiftsCurrentCoins,
  GiftsHeader,
  GiftsWrapper,
} from './Redeem.styles';
import { useTranslation } from 'react-i18next';
import { formatNumber } from 'helpers/GlobalHelper';
import GroupCoins from 'assets/icons/coins/Groupcoins.png';
import { RedeemCoins } from 'components/RedeemCard/RedeemCard.styles';
import useRewards from 'store/useRewards';
import RedeemCard from 'components/RedeemCard';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { GET_COUPONS } from 'config/queries';
import { createNewCoupon, getCouponHistory } from 'routes/services/Redeem';
import useUser from 'store/useUser';
import { useNavigate } from 'react-router-dom';
import { Empty, Loading } from 'components/LottieFiles';
import useRedeem from 'store/useRedeem';
import Modal from 'components/Modal';

interface couponProps {
  _id: string;
  balance: number;
  cost: number;
  couponCode: string;
  product: string;
  userId: string;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}
const Home = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { coins, setCoins } = useRewards();
  const { isLogged, visitorId } = useUser();
  const { products, history, setProducts, setCoupons } = useRedeem();

  // states
  const [loading, setLoading] = useState<boolean>(false);

  // eslint-disable-next-line
  const historyList = useQuery(GET_COUPONS, () => getCouponHistory(visitorId));

  useEffect(() => {
    // udate products with redmeed state
    if (history) {
      // eslint-disable-next-line
      products.map((item: any) => {
        // eslint-disable-next-line
        history.map((coupon: any) => {
          if (item._id === coupon.product) {
            item.state = 'redeemed';
          }
        });
      });

      setProducts(products);
    }
    // eslint-disable-next-line
  }, [history]);

  // check if coins available to redeem an item
  useEffect(() => {
    if (!isLogged) {
      navigate('/start');
    }

    // updated every 1sec
    const interval = setInterval(() => {
      // eslint-disable-next-line
      products.map((item: any) => {
        countDown(item);
        if (
          (item.coins > coins || item.coins === 0) &&
          item.state !== 'redeemed'
        ) {
          item.state = 'locked';
          // eslint-disable-next-line
        } else if (item.state === 'onRedeem' || item.state === 'redeemed') {
          // eslint-disable-next-line
          return;
        } else item.state = 'open';
      });

      setProducts(products);
    }, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [products]);

  const handleRedeem = (item: any) => {
    setLoading(true);
    const data = {
      product: item._id,
      userId: visitorId + '',
      balance: coins,
    };
    if (item.coins <= coins && item.state === 'open') {
      createNewCoupon(data)?.then((res: couponProps) => {
        if (res) {
          setCoupons(res);
          setLoading(false);
        }
      });
      setCoins(coins - item.coins);
      setProducts(
        products.map((product: any) =>
          product._id === item._id
            ? { ...product, state: 'onRedeem', RedeemTime: new Date() }
            : product,
        ),
      );
      navigate(`redeem/${item._id}`);
    }

    if (item.state === 'onRedeem') {
      setLoading(false);
      navigate(`redeem/${item._id}`);
    }
  };

  // create  24h countdown satrs from RedeemTime
  const countDown = (item: any) => {
    if (item.RedeemTime) {
      // add 24h to redeemTime
      const redeemTime = new Date(item.RedeemTime);
      redeemTime.setHours(redeemTime.getHours() + 24);
      // get current time
      const now = new Date();
      // get the difference between now and redeemTime
      const diff = redeemTime.getTime() - now.getTime();
      // convert to hours
      const hours = Math.floor(diff / (1000 * 60 * 60));
      // convert to minutes
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      // convert to seconds
      const seconds = Math.floor((diff / 1000) % 60);

      if (hours + minutes + seconds <= 0 && item.state !== 'redeemed') {
        item.state = 'expired';
        // update products

        products.map((product: any) =>
          product._id === item._id ? { ...product, state: 'expired' } : product,
        );
      }

      // return the time
      return { hours, minutes, seconds };
    }
  };

  return (
    <GiftsWrapper>
      <GiftsHeader>
        <Title level={1} renderAs="h1">
          {t('swappointsgift')}
        </Title>
        <GiftsCurrentCoins>
          {t('currentcoins')} <RedeemCoins src={GroupCoins} alt={coins + ''} />
          {formatNumber(coins)}
        </GiftsCurrentCoins>
      </GiftsHeader>
      {products && products.length > 0 ? (
        <GiftGrid className="hideScroll">
          {products.map((item: any, index) => (
            <RedeemCard
              key={index}
              cost={item.coins}
              name={item.name}
              img={item?.media[0]?.location || item.img}
              state={item.state}
              reduction={item.reduction}
              countDown={countDown(item)}
              onClick={() => handleRedeem(item)}
            />
          ))}
        </GiftGrid>
      ) : (
        <span className="w-full">
          <Empty />
        </span>
      )}
      <Modal isOpen={loading} closeModal={() => {}}>
        <Loading />
      </Modal>
    </GiftsWrapper>
  );
};

export default Home;
